<template>
	<el-container>
		<el-header>
			<ul style="float: left;">
				<li><a href="javascript:;" class="uploadfile">装载名单
						<input type="file" name="" id="" @change="getFile($event)" :accept="myaccept">
					</a>
					<el-button type="warning" style="margin:10px 5px 0px 10px;" @click="CheckErr()">数据校验</el-button>
					<el-button type="danger" style="margin:10px 5px 0px 10px;" @click="InputData()">导入系统</el-button>
				</li>
			</ul>



		</el-header>
		<el-main>
			<el-table border ref="multipleTable" tooltip-effect="dark" :data="cuslist.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<el-table-column prop="err" label="校验" width="200">
					<template slot-scope="scope">
						<li v-if="scope.row.errm!=''" style=" color: #F56C6C;">【请修正】{{scope.row.errm}}</li>
						<li v-if="scope.row.err!=''" style=" color:gold;">【请注意】{{scope.row.err}}</li>
					</template>
				</el-table-column>
				<el-table-column prop="cusname" label="姓名" width="160px"></el-table-column>
				<el-table-column prop="cussex" label="适用性别">
					<!-- <template slot-scope="scope">
					<div v-for="item in AdaptSex">
						<label v-if='scope.row.cussex==item.value'>{{item.key}}</label>
					</div>
				</template> -->
				</el-table-column>
				<el-table-column prop="cusmarry" label="婚否" width="60">
					<!-- <template slot-scope="scope">
					<div v-for="item1 in AdaptMarry">
						<label v-if='scope.row.cusmarry==item1.value'>{{item1.key}}</label>
					</div>
				</template> -->
				</el-table-column>
				<el-table-column prop="cusbirthday" label="出生日期" width="120"></el-table-column>
				<el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
				<el-table-column prop="idcard" label="身份证号" width="180"></el-table-column>
				<el-table-column prop="groupname" label="分组"></el-table-column>
				<el-table-column prop="memo" label="备注"></el-table-column>

			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[10, 20, 40,80]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="cuslist.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
	</el-container>
</template>

<script>
	import ordercus from '../../apifunction/OrderCus.js'
	import ordergroup from '../../apifunction/OrderGroup.js'
	export default {
		created() {
			this.initData()
		},
		data() {
			return {
				myaccept:'.xlsx',
				orderent: this.inorder,
				ordergrouplist: [],
				cuslist: [],
				AdaptSex: this.$enums.AdaptSex,
				AdaptMarry: this.$enums.AdaptMarry,
				currentPage: 1,
				pagesize: 10,
				ischeckcus: false
			}
		},
		watch: {
			"$route": "initData"
		},
		props: ['inorder'],
		methods: {
			initData() {
				ordergroup.GetOrderGroupData(this.orderent.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null')
								this.ordergrouplist = JSON.parse(ent.Data);
							else
								this.ordergrouplist = [];

						} else
							this.$message.info(ent.Msg);
					})
			},
			getFile(event) {
				//alert(JSON.stringify(event.target.files))
				var file = event.target.files;

				// 上传类型判断
				var imgName = file[0].name;
				var idx = imgName.lastIndexOf(".");
				if (idx != -1) {
					var ext = imgName.substr(idx + 1).toUpperCase();
					ext = ext.toLowerCase();
					if (ext != 'xlsx') {
						alert('文件格式不支持！')
					} else {
						this.ischeckcus = false;
						let param = new FormData(); //创建form对象
						param.append('file', file[0]); //通过append向form对象添加数据
						//param.append('branch_id', row.branch_id);
						ordercus.GetOrderCusByExcel(param)
							.then(res => {
								let ent = JSON.parse(JSON.stringify(res.data))
								if (ent.Flag == 'success') {
									if (ent.data != 'null') {
										let temp = JSON.parse(ent.Data);
										for (let i = 0; i < temp.length; i++) {
											if(temp[i].cusbirthday!='')
											{
												temp[i].cusage=this.CommonFun.BirthdayToAge(temp[i].cusbirthday);
											}
											temp[i].errm = '';
											temp[i].err = '';
										}
										this.cuslist = temp;

									} else
										this.cuslist = [];

								} else
									this.$message.info(ent.Msg);
							})
					}
				} else {

				}
				event.target.value = '';
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			CheckErr() {
				if (this.cuslist == null || this.cuslist.length < 1) {
					this.$message.info('请加载名单！');
					return;
				}
				if (this.ordergrouplist == null || this.ordergrouplist.length < 1) {
					this.$message.info('请先设置订单分组！');
					return;
				}
				ordercus.CheckErr(this.cuslist, this.ordergrouplist);
				this.ischeckcus = true;
this.$message.info("校验完成！");
			},
			InputData() {
				if (this.cuslist.length < 1)
					return;
				if (!this.ischeckcus) {
					this.$message.info("请点击'数据校验'按钮,检查数据有效性！");
					return;
				}
				let tm = this.cuslist.find(f => {
					return f.errm != ''
				});
				if (tm != null) {
					this.$message.info("名单校验有异常，请修正！");
					return;
				}
				let t = this.cuslist.find(f => {
					return f.err != ''
				});
				if (t != null)
				{	this.$confirm('名单校验有异常提醒，确定要强行导入吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(res => {
						for (let i = 0; i < this.cuslist.length; i++) {
							ordercus.AddCus(this.getcusinfo(this.cuslist[i]))
						}
						this.$message.info("导入完成！");
						this.cuslist=[];
					});
					}
					else
					{
						for (let i = 0; i < this.cuslist.length; i++) {
							ordercus.AddCus(this.getcusinfo(this.cuslist[i]))
						}
						this.$message.info("导入完成！");
						this.cuslist=[];
					}
			},
			getcusinfo(ent) {
				let user = this.$myglobal.getUserInfo();
				let sex = '';
				if (ent.cussex == '男')
					sex = '1'
				if (ent.cussex == '女')
					sex = '2'
				let marry = '0';
				if (ent.cusmarry == '已婚')
					marry = '1';
				if (ent.cusmarry == '未婚')
					marry = '2';
				let groupname = ent.groupname;
				let grp = this.ordergrouplist.find(f => {
					return f.GroupName == groupname;
				});
				let grpid = grp == null ? "" : grp.GroupID;
				return {
					id: this.CommonFun.NewGuid(),
					cusname: ent.cusname,
					cussex: sex,
					cusbirthday: ent.cusbirthday,
					cusmarry: marry,
					mobile: ent.mobile,
					idcard: ent.idcard,
					cusstatus: '10',
					memo: ent.memo,
					orderid: this.orderent.OrderID,
					groupid: grpid,
					corpid: user.corpid
				}
			}
		}
	}
</script>

<style>
</style>
